import useFetch from "services/hooks/useFetch";
import { getCookie, removeCookie, setCookie } from "./CookieHandler";
import { ApiUrls } from "./globalVariables";
import { useEffect, useRef, useState } from "react";
import { post } from "services/httpClient";
import { dispatchHandler, useContextDispatch, useContextState } from "services/context/MainContext";
import { actionTypes } from "services/context/reducer";
import { CircularProgress, Stack } from "@mui/material";
import Logo from "./../../assets/images/Logo.svg";

export default function LoginService({ children }) {
    const [{}, doFetchInfo] = useFetch(ApiUrls.GetCustomerInfo, "get")
    const [{}, doFetchSync] = useFetch(ApiUrls.SyncScore, "get")

    const minsTillRenew = 50

    const [isLoaded, setIsLoaded] = useState(false)
    const [isLoggedOut, setIsLoggedOut] = useState(false)
    const refreshTimeout = useRef(null)

    const dispatch = useContextDispatch()
    const { GET_USERINFO } = actionTypes

    const loginData = getCookie("loginData")

    const logoutUser = () => {
        if (isLoggedOut) return
        setIsLoggedOut(true)
        removeCookie("loginData")

        if (refreshTimeout.current) {
            clearTimeout(refreshTimeout.current)
            refreshTimeout.current = null
        }

        setTimeout(() => {
            window.location.reload()
        }, 100)
    }

    const handleLoginService = async () => {
        if (!loginData || isLoggedOut) {
            return;
        }

        setIsLoaded(false)

        try {
            const storedExpiry = loginData?.accessTokenExpiry ? new Date(loginData.accessTokenExpiry) : null
            const now = new Date()

            if (storedExpiry && now < storedExpiry) {
                setIsLoaded(true)

                doFetchSync(null, () => {
                    doFetchInfo(null, (res2) => dispatchHandler(dispatch, GET_USERINFO, { userInfo: res2.Data }))
                })

                const timeUntilRefresh = storedExpiry - now - 50000

                refreshTimeout.current = setTimeout(() => {
                    if (!isLoggedOut) handleLoginService()
                }, timeUntilRefresh)

                return
            }

            const res = await post(ApiUrls.JwtExtendtoken, { "rtoken": loginData.renewalToken })

            if (!res || res.status === 401) {
                logoutUser()
                return
            }

            handleRenewal(res)

        } catch (error) {
            console.error("JWT Renewal Error:", error)
        } finally {
            setIsLoaded(true)
        }
    }

    const handleRenewal = (res) => {
        if (res) {
            const newExpiry = new Date();
            newExpiry.setMinutes(newExpiry.getMinutes() + minsTillRenew)

            const updatedLoginData = { ...res, accessTokenExpiry: newExpiry.toISOString() }
            setCookie("loginData", updatedLoginData, 14)

            doFetchSync(null, () => {
                doFetchInfo(null, (res2) => dispatchHandler(dispatch, GET_USERINFO, { userInfo: res2.Data }))
            })
        } else {
            logoutUser()
        }
    };

    useEffect(() => {
        if (!getCookie("loginData")) return

        handleLoginService()
    }, [])

    if (isLoaded || !loginData) {
        return <div>{children}</div>
    } else {
        return (
            <Stack spacing={2} sx={{ width: "100%", height: "100vh", marginTop: "-60px" }} alignItems="center" justifyContent="center">
                <img style={{ width: "260px", height: "45px" }} src={Logo} alt="لوگو پاکسرشت هوم" />
                <CircularProgress />
            </Stack>
        );
    }
}
